import { Employer } from "@entities/employer";

export enum VacancyableType {
  INDUSTRIAL_VACANCY = "industrial_vacancy",
  MICRO_VACANCY = "micro_vacancy",
}

export type Vacancy = {
  id: string;
  employer: Employer;
  title: string;
  region: {
    id: string;
    name: string;
  };
  minSalaryAmount: number;
  minSalaryCurrency: string;
  maxSalaryAmount: number;
  maxSalaryCurrency: string;
  showSalary: boolean;
  publishedAt: string | number;
  platform: {
    id: string;
    name: string;
    logoUrl: string;
    isInternal: boolean;
    link: string;
  };
  platformName: string;
  platformLogo: string;
  platformType: "external" | "internal";
  platformLink: string;
  expiresAt: string;
  availableQuota: number;
  quota: number;
  accepted: number;
  companyLogoUri: string;
  companyName: string;
  cityName: string;
  jobTypeName: string;
  jobType: {
    name: string;
  };
  job: {
    id: string;
    description: string;
    budgetCurrency: string;
    minBudgetAmount: number;
    maxBudgetAmount: number;
    minBudget: {
      currency: string;
    };
    title: string;
    employer: Employer;
    region: {
      id: string;
      name: string;
    };
    expireAt: string;
    skills: string[];
  };
  jobId: string;
  jobFunctionId: string;
  jobFunction: {
    id: string;
    name: string;
  };
  vacancyableType: VacancyableType;
  vacancyableId: string;
  gender: "male" | "female" | null;
  description: string;
  qualification: string;
  minEducationId: string;
  minEducation: {
    id: string;
    name: string;
  };
  education: {
    id: string;
    name: string;
  };
  maritalStatus: "single" | "married" | "widower" | "widow" | "divorced" | "death_divorced" | null;
  marital: "single" | "married" | "widower" | "widow" | "divorced" | "death_divorced" | null;
  physicalCondition: "normal" | 10 | "disability" | "disabled" | 20 | null;
  physical: "normal" | 10 | "disability" | "disabled" | 20 | null;
  minYearExperience: number | null;
  skills: string[];
  micro: {
    minExperience: number | null;
  }
};